import { Text } from "../tailwind/text";
import { Button } from "../tailwind/button";
import { PhoneIcon } from "@heroicons/react/16/solid";
import { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../tailwind/dialog";
import { api } from "../../api";
import { Field, Label } from "../tailwind/fieldset";
import { Input } from "../tailwind/input";
import { cleanPhone } from "../../functions/cleanPhone";
import { message } from "antd";

export function DisplayAdvices({ customer, user }) {
  const bannerParams = {
    scheduleACall: {
      bgColor: "#fbf3cb",
      btnText: "Schedule a call",
      btnIcon: <PhoneIcon className="text-yellow w-6" />,
      onClick: () =>
        window.open(
          "https://calendly.com/pauline-getsimio/rdv-csm?utm_source=dashboard",
          "_blank",
          "noopener,noreferrer",
        ),
      bannerHeadline: "Need advice?",
      bannerText:
        "Book a FREE call with our experts to get personalized guidance and strategies.",
    },
    addUserPhone: {
      bgColor: "#effadd",
      btnText: "Add my phone",
      btnIcon: <PhoneIcon className="text-yellow w-6" />,
      onClick: () => setIsAddPhoneModalOpen(true),
      bannerHeadline: "Make testing easier!",
      bannerText: "Add your phone number to receive test messages.",
    },
  };

  // Add user phone
  const [isAddPhoneModalOpen, setIsAddPhoneModalOpen] = useState(false);
  const [isAddPhoneLoading, setIsAddPhoneLoading] = useState(false);
  const [phone, setPhone] = useState(user?.phone || "");

  const [bannerState, setBannerState] = useState("scheduleACall");

  useEffect(() => {
    if (!user?.phone) {
      setBannerState("addUserPhone");
    } else {
      setBannerState("scheduleACall");
    }
  }, [user]);

  const currentBanner = bannerParams[bannerState];

  if (!currentBanner) return null;

  return (
    <>
      <div
        style={{ backgroundColor: currentBanner.bgColor }}
        className="w-full flex flex-col sm:flex-row sm:justify-between sm:items-center py-2 px-4 rounded-customBorderRadius"
      >
        <Text className="text-black">
          <span className="font-bold text-lg whitespace-nowrap">
            {currentBanner.bannerHeadline}
          </span>
          <span> {currentBanner.bannerText}</span>
        </Text>

        <Button
          color="dark"
          onClick={currentBanner.onClick}
          className="ml-0 sm:ml-2 font-bold mt-2 sm:mt-0"
        >
          <div className="text-yellow">{currentBanner.btnIcon}</div>
          <span className="text-yellow">{currentBanner.btnText}</span>
        </Button>
      </div>

      <Dialog
        key="dialog_add_user_phone"
        open={isAddPhoneModalOpen}
        onClose={() => setIsAddPhoneModalOpen(false)}
      >
        <DialogTitle>Add your phone number</DialogTitle>

        <DialogBody className="flex-1 overflow-y-auto scrollbar">
          Update your profile to add your phone number and receive test
          messages.
          <Field className={"mt-4 mx-1"}>
            <Label>Phone Number</Label>
            <Input
              value={phone}
              maxLength={15}
              onChange={(e) =>
                setPhone(cleanPhone(e.target.value.replace(/[^0-9]/g, "")))
              }
              autoComplete="off"
            />
          </Field>
        </DialogBody>
        <DialogActions>
          <Button
            color="secondaryButton"
            onClick={() => setIsAddPhoneModalOpen(false)}
            disabled={isAddPhoneLoading}
            className="min-w-[100px] h-10"
          >
            Cancel
          </Button>
          <Button
            color="primaryButton"
            onClick={async () => {
              setIsAddPhoneLoading(true);
              try {
                await api.user.update(user.id, {
                  phone,
                });
                setIsAddPhoneLoading(false);
                message.success("Phone number updated!");
              } finally {
                setIsAddPhoneModalOpen(false);
              }
            }}
            className="min-w-[100px] h-10"
            loading={isAddPhoneLoading}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
